document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.js-form-email-validate');
  // Add an event listener to each form on the page
  forms.forEach((form) => {
    form.addEventListener('triggerSignupOnGTM', () => {
      // Get the email from the form to send to lytics
      const emailField = form.querySelector('input[name="email"]');
      const emailValue = emailField.value;

      if (typeof jstag !== 'undefined') {
        const email = emailValue;
        const payload = {
          email,
          _e: 'Email lookup',
        };
        // eslint-disable-next-line no-undef
        jstag.send(payload);
      }
    });
  });
});
